/**
 * Open PDFs in new window
 */
function linksCustomization(){
	var pdfLinks = document.querySelectorAll('a[href$=".pdf"]')

	pdfLinks.forEach(pdf => {
		pdf.setAttribute('target', '_blank');
	});
}

/**
 * Adds smooth scrolling to anchor links
 * 
 * Adds data-scroll-to attribute to anchor links without it.
 */
function scrollTo(){
	// Function to handle smooth scrolling for anchor links
	function smoothScroll(target, offset) {
		const element = document.querySelector(target);
	
		if (element) {
			window.scrollTo({
				top: element.offsetTop - offset,
				behavior: 'smooth'
			});
		}
	}

	// Detect all anchor links on the page without data-scroll-to attribute
	const scrollToLinks = document.querySelectorAll('a[href^="#"]:not([data-scroll]):not([class^="magnific-"])')
	scrollToLinks.forEach(link => {
		// Skip those with only the hashtag
		if (link.getAttribute('href').length > 1) {
			link.setAttribute('data-scroll', 'scroll-to');
		}
	});

	
	// Event listener for anchor links
	let anchorLinks = document.querySelectorAll( '[data-scroll="scroll-to"]' )

	anchorLinks.forEach(element => {
		element.addEventListener('click', function(event) {
			const target = event.target;
		
			event.preventDefault(); // Prevent default anchor link behavior
		
			let offset = 50; // Adjust this value to set the desired offset
			if ( target.getAttribute('data-scroll-space') ){
				offset = target.getAttribute('data-scroll-space')
			}
			smoothScroll(target.getAttribute('href'), offset); // Smooth scroll to the target element with an offset
		});
	});
}

/**
 * Adds a class to tablepress tables to make them responsive.
 */
function responsiveTables(){
	/* if ( document.querySelectorAll('.tablepress').length > 0 ) {
		const tables = document.querySelectorAll('.tablepress');

		var wrap = function (toWrap, wrapper) {
			wrapper = wrapper || document.createElement('div');
			wrapper.classList.add('responsive-table');
			toWrap.parentNode.appendChild(wrapper);
			return wrapper.appendChild(toWrap);
		};

		[...tables].forEach((table) => {
			wrap(table);
		});
	} */
	if ( document.querySelectorAll('.prose table').length > 0 ) {
		const tables = document.querySelectorAll('.prose table');

		var wrap = function (toWrap, wrapper) {
			wrapper = wrapper || document.createElement('div');
			wrapper.classList.add('responsive-table');
			
			// Insert the wrapper before the toWrap element
			toWrap.parentNode.insertBefore(wrapper, toWrap);
			
			return wrapper.appendChild(toWrap);
		};

		[...tables].forEach((table) => {
			wrap(table);
		});
	}
}

export { linksCustomization, scrollTo, responsiveTables }